import { IPlanEnrollment } from "./types";
import { planEnrollmentService } from "./service";

export const cancelPlanEnrollment = async (
  planEnrollmentId: string
): Promise<IPlanEnrollment> => {
  const { data } = await planEnrollmentService.post(
    `/${planEnrollmentId}/cancel`
  );
  return data;
};
